import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { AuthDetails } from 'tsconfig/types';

export interface AuthStore {
  auth: AuthDetails;
  setAuth: (auth: AuthDetails) => void;
  updateAuth: (partial: Partial<AuthDetails>) => void;
  reset: () => void;
}

const initialAuth: AuthDetails = {
  isInitialised: false,
  publicCsrf: '',
};

export const useAuthStore = create<AuthStore>()(
  devtools(
    set => ({
      auth: initialAuth,
      setAuth: auth => set({ auth }, undefined, 'setAuth'),
      updateAuth: partial => set(state => ({ auth: { ...state.auth, ...partial } }), undefined, 'updateAuth'),
      reset: () => set({ auth: initialAuth }, undefined, 'reset'),
    }),
    { name: 'AuthStore' },
  ),
);
